import ChastityImage from '../../assets/images/backgrounds/lady-cinder-session-background-chastity.webp';
import HypnoImage from '../../assets/images/backgrounds/lady-cinder-session-background-hypno.webp';
import SexImage from '../../assets/images/backgrounds/lady-cinder-session-background-sex.webp';
import WorshipImage from '../../assets/images/backgrounds/lady-cinder-session-background-worship.webp';
import FireImage from '../../assets/images/backgrounds/lady-cinder-session-background-fire-worship.webp';
import MindImage from '../../assets/images/backgrounds/lady-cinder-session-background-mind-fuck.webp';

export const favoriteSessionsArray = [
  {
    title: 'Hypnotic Indoctrination (Online & In-Person)',
    description:
      'Eyes ever watching. I rewrite your thoughts until obedience feels like oxygen. You sink, I speak, you obey.',
    image: HypnoImage,
  },
  {
    title: 'Mindfuck & Propaganda Play',
    description:
      'Mantras, triggers, and ritual messaging. You repeat, you believe, and you belong to Me—body, mind, and myth.',
    image: MindImage,
  },
  {
    title: 'Sensual Sadism & Fire Ritual',
    description:
      'Heat, sting, and velvet control. Circus-bred precision—when I breathe fire, you tremble and thank Me.',
    image: FireImage,
  },
  {
    title: 'Deity Worship: Body • Boots • Feet',
    description:
      'Not just a goddess—an actual deity. You adore My strength, trace every curve, and kiss the altar at My feet.',
    image: WorshipImage,
  },
  {
    title: 'Chastity, Tease & Devotional Denial',
    description:
      'Locked, teased, and kept on edge. Your release is a sacrament I control—and you’ll beg to stay denied.',
    image: ChastityImage,
  },
  {
    title: 'Protocol & Slave Training',
    description:
      'Discipline, doctrine, and perfect service. I shape you into a useful creature—polished, obedient, and proud to serve.',
    image: SexImage,
  },
];

export const sessionRates = [
  { label: 'Event Hosting', price: '$150/hr (4 hour minimum)' },
  {
    label: 'Domme Demos / BDSM Performance',
    price: '$250/set (30 min max per set, 2 hour minimum)',
  },
  {
    label: 'Sideshow Performances',
    price:
      '$150/hr (multiple acts available, 6 sets max — time calculated from call time to end of last set)',
  },
  {
    label: 'BDSM Sessions',
    price: 'Starting at $500/hr (individual rate depends on kinks requested)',
  },
  { label: 'Teaching', price: '$250/hr' },
  { label: 'All Day (6+ Hours)', price: '$2000 Minimum' },
  { label: 'Overnight', price: '$2500 Minimum' },
  { label: 'FMTY', price: '$2000 Minimum' },
  { label: 'Cash Meets', price: '$150 Minimum' },
  { label: 'Shopping', price: '$100 Deposit, $200 Minimum' },
];

export const offeringsArray = [
  { label: 'Armpit Worship (Clean)' },
  { label: 'Armpit Worship (Dirty)' },
  { label: 'Ballbusting' },
  { label: 'Bondage' },
  { label: 'Body Worship' },
  { label: 'CBT' },
  { label: 'CEI' },
  { label: 'Chastity' },
  { label: 'Denim' },
  { label: 'Degradation' },
  { label: 'Domestic Tasks / Domestic Slave' },
  { label: 'Edging' },
  { label: 'Encouraged Bi' },
  { label: 'Facesitting' },
  { label: 'Farts' },
  { label: 'Financial Domination' },
  { label: 'Foot Worship (Clean)' },
  { label: 'Foot Worship (Dirty)' },
  { label: 'Gags' },
  { label: 'Golden Shower' },
  { label: 'Gooning' },
  { label: 'Gym role play/spandex/leggings' },
  { label: 'Human Ashtray' },
  { label: 'Human Furniture' },
  { label: 'Humiliation (Light)' },
  { label: 'Humiliation (Heavy)' },
  { label: 'Ignoring' },
  { label: 'JOI' },
  { label: 'Leather' },
  { label: 'Mind fuck ' },
  { label: 'Muscle Domination ' },
  { label: 'Nipple Play' },
  { label: 'Oil' },
  { label: 'Orgasm control' },
  { label: 'Pantyhose/Fishnet Worship' },
  { label: 'Pet Play' },
  { label: 'Role play' },
  { label: 'Shopping Trips' },
  { label: 'Sensual Domination' },
  { label: 'Slave & Slut Training' },
  { label: 'Sneaker/Heel/Boot Worship' },
  { label: 'SPH' },
  { label: 'Spitting' },
  { label: 'Strap-On Worship/Pegging' },
  { label: 'Tease and Denial' },
  { label: 'Trampling' },
  { label: 'Wedgie' },
];

export const exclusionsArray = [
  { label: 'No scat.' },
  { label: 'No blood.' },
  { label: 'No needles.' },
  { label: 'No medical play.' },
  { label: 'No blackmail (BM).' },
  { label: 'No race play.' },
  { label: 'No CNC.' },
  { label: 'No sissification.' },
  { label: 'No intox.' },
];
